import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '@mcn-platform/models';
import MeetingSummaryWidget from './MeetingSummaryWidget';
import { WysiwygViewer } from '../../publisher/wysiwyg/WysiwygEditor';
const PreMeeting = ({ meeting, settings, }) => {
    const store = useStore();
    const { currentRegistration, startPollingModel, stopPollingModel, } = store;
    const { registrationRequired } = meeting;
    useEffect(() => {
        if (!!currentRegistration || !registrationRequired) {
            startPollingModel('meeting', meeting.id, 3000);
        }
        return () => {
            stopPollingModel('meeting', meeting.id);
        };
    }, [startPollingModel, stopPollingModel, meeting.id, currentRegistration]);
    return (_jsxs(_Fragment, { children: [_jsx(WysiwygViewer, { id: `pre-meeting-content-${meeting.key}`, value: meeting.preMeetingMessage?.slate }), _jsx(MeetingSummaryWidget, { meetingKey: meeting.key, settings: settings }), _jsx(WysiwygViewer, { id: `meeting-content-${meeting.key}`, value: meeting.content?.slate })] }));
};
export default observer(PreMeeting);
//# sourceMappingURL=PreMeeting.js.map